import React from 'react';
import { useParams } from 'react-router-dom';
import { SupportFeedPage } from '@components/feed-preview/support-feed-page';

const TeamFeed = () => {
    const { teamId } = useParams();

    if (!teamId) {
        return null;
    }

    return <SupportFeedPage entityId={Number(teamId)} entityType="team" />;
};

export default TeamFeed;
